export const redirectToNewDoc = (
  itemId: string,
  openAiWidget: boolean,
  companyId: string
) => {
  let url = `/${companyId}/items/${itemId}`
  if (openAiWidget) {
    url += '?widget=PEPPER_AI'
  }
  window.open(url, '_blank')
}
